export default {
  // 全局配置
  setOptions: {
    chart: {
      spacing: 20,
      backgroundColor: 'transparent'
    },
    credits: { // 版权信息
      enabled: false
    },
    title: { // 标题
      text: null
    },
    legend: {
      enabled: true, // 默认有图例
      layout: 'horizontal',
      align: 'left',
      verticalAlign: 'top',
      itemStyle: {
        color: '#3A8BE6',
        fontsize: '14px'
      }
    },
    plotOptions: {
      column: {
        borderWidth: 0
      },
      line: {
        lineWidth: 1,
        marker: {
          radius: 3
        }
      }
    },
    xAxis: {
      lineWidth: 1,
      lineColor: '#162F7B',
      gridLineWidth: 0,
      labels: {
        style: {
          color: '#C5D3FF',
          fontSize: '12px'
        }
      }
    },
    yAxis: {
      lineWidth: 1,
      lineColor: '#162F7B',
      title: {text: null},
      labels: {
        style: {
          color: '#C5D3FF',
          fontSize: '12px'
        }
      },
      gridLineColor: '#162F7B',
      gridLineDashStyle: 'LongDash'
    }
  },
  /** 地图配置 */
  mapOptions: {
    title: {
      text: '',
      style: {
        color: '#286CE3',
        fontSize: '20px',
        fontWeight: 800
      }
    },
    legend: false,
    tooltip: {
      formatter: () => {
        console.log('tooltio: ', this);
        // return `城市：${this.point.name} <br> 值：${this.point.value}`;
      }
    },
    plotOptions: {
      map: {
        nullColor: ' #CFE7F9',
        borderColor: '#08153D',
        states: {
          hover: {
            color: '#0ACCB4'
          }
        }
      }
    },
    colorAxis: {
      min: 0,
      minColor: '#567BE8',
      maxColor: '#1A4DE5',
      labels: {
        style: {
          color: 'red', fontWeight: 'bold'
        }
      }
    },
    series: [{
      data: [],
      mapData: [],
      joinBy: 'name',
      name: ''
    }]
  },
  // 折线图
  lineOptions: {
    chart: {
    },
    legend: {
      enabled: false
    },
    colors: ['#286CE3'],
    tooltip: {
    },
    yAxis: {
    },
    xAxis: {
      categories: []
    },
    plotOptions: {
      areaspline: {
        fillOpacity: 0.5
      },
      series: {
      }
    },
    series: [{
      name: '住户数',
      data: []
    }]
  },
  // 柱状图
  columnOptions: {
    chart: {
      type: 'column',
      // spacingRight: 50,
      marginRight: 0,
      options3d: {
        enabled: true,
        alpha: 0,
        beta: 0,
        depth: 20
      }
    },
    legend: {
      enabled: false
    },
    colors: [{ // 调色板
      linearGradient: [0, 0, 0, 200],
      stops: [[0, '#3BB6FF'], [1, '#264EDD']]
    }],
    plotOptions: {
      column: {
        depth: 25
      }
    },
    yAxis: {
      // tickInterval: 100 // y轴刻度的间隔值
    },
    xAxis: {
      labels: {
        style: {fontSize: '12px'}
      },
      categories: []
    },
    series: [{
      name: '',
      data: []
    }]
  },
  // 堆叠柱状图
  stackColOptions: {
    chart: {
      type: 'column'
    },
    colors: ['#3A8BE6', '#916BFE', '#15DB75', '#F8665D', '#F98F3B', '#95D515', '#0ACCB4', '#FFC292', '#5AA8BC'],
    legend: {
      enabled: true,
      padding: 4,
      symbolRadius: 1,
      itemDistance: 1,
      itemHoverStyle: {
        color: '#C5D3FF'
      }
    },
    xAxis: {
      categories: []
    },
    yAxis: {
    },
    tooltip: {
      shared: false
    },
    plotOptions: {
      column: {
        stacking: 'normal'
      }
    },
    series: [
      {
        name: '人脸',
        data: []
      },
      {
        name: '蓝牙',
        data: []
      },
      {
        name: '远程',
        data: []
      },
      {
        name: '密码',
        data: []

      },
      {
        name: '刷卡',
        data: []
      },
      {
        name: '云对讲',
        data: []
      },
      {
        name: '室内对讲',
        data: []
      },
      {
        name: '室内远程',
        data: []
      },
      {
        name: '电话开门',
        data: []
      },
      {
        name: '访客密码',
        data: []
      }
    ]
  },
  // 实时开门
  realOpenOptions: {
    chart: {
    },
    colors: ['#3A8BE6', '#916BFE', '#15DB75', '#F8665D', '#F98F3B', '#95D515', '#0ACCB4', '#FFC292', '#5AA8BC'],
    yAxis: {
    },
    xAxis: {
      categories: []
    },
    legend: {
      enabled: true,
      itemHoverStyle: {
        color: '#C5D3FF'
      }
    },
    plotOptions: {
      line: {
        pointStart: 0
      }
    },
    series: [
      {
        name: '人脸',
        data: []
      },
      {
        name: '蓝牙',
        data: []
      },
      {
        name: '远程',
        data: []
      },
      {
        name: '密码',
        data: []
      },
      {
        name: '刷卡',
        data: []
      },
      {
        name: '云对讲',
        data: []
      },
      {
        name: '室内对讲',
        data: []
      },
      {
        name: '室内远程',
        data: []
      },
      {
        name: '电话开门',
        data: []
      },
      {
        name: '访客密码',
        data: []
      }
    ],
    responsive: {
      rules: [{
        condition: {
          maxWidth: 500
        },
        chartOptions: {
          legend: {
            layout: 'horizontal',
            align: 'center',
            verticalAlign: 'bottom'
          }
        }
      }]
    }
  },
  // 报修统计
  repairOptions: {
    chart: {
      type: 'variablepie',
      margin: 0,
      marginRight: 200,
      backgroundColor: 'transparent'
    },
    colors: ['#916BFE', '#F98F3B', '#15DB75', '#F8665D'],
    legend: {
      enabled: true,
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      x: -40,
      itemMarginTop: 10,
      symbolRadius: '1px',
      squareSymbol: false,
      symbolWidth: 22,
      symbolPadding: 10,
      itemHoverStyle: {
        color: '#C5D3FF'
      },
      itemStyle: {
        color: '#3A8BE6',
        fontsize: '14px'
      },
      labelFormatter () {
        return `<span style="font-family:Roboto;font-size:14px;font-weight:100">${this.name}</span>
        <span style="color:#C5D3FF;font-size:16px;font-family: DINAlternate-Bold"> ${this.y}% ${this.num}件</span>`;
      }
    },
    tooltip: {
      headerFormat: '',
      pointFormatter () {
        return `<span style="color: ${this.color}">${this.name}</span>：<br>
                    <span>${this.y}%</span>`;
      }
    },
    plotOptions: {
      variablepie: {
        size: '90%',
        borderWidth: 0,
        cursor: 'pointer',
        dataLabels: {
          enabled: false
        },
        showInLegend: true
      }
    },
    series: [{
      colorByPoint: true,
      innerSize: '45%',
      size: '100%',
      data: []
    }]
  },
  // 饼状图 配置为函数
  pieOptions () {
    return {
      chart: {
        margin: 0,
        type: 'pie'
      },
      legend: {
        enabled: false
      },
      colors: ['#B8A0FF', '#8158F7', '#FFC292', '#F98F3B'],
      title: {
        floating: true
      },
      tooltip: {
        formatter () {
          return `<span style="color:${this.color}">${this.key}</span>：<br>
        <span style="font-family:DINAlternate-Bold">${this.y}%</span>`;
        }
      },
      plotOptions: {
        pie: {
          size: '80%',
          showInLegend: true,
          cursor: 'pointer',
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            inside: true,
            distance: 10,
            padding: 0,
            connectorPadding: 0,
            color: '#C5D3FF',
            connectorColor: '#286CE3',
            useHtml: true,
            rotation: 0,
            crop: false,
            overflow: 'none',
            style: {fontSize: '12px', fontWeight: 'normal', textOutline: 'none'},
            formatter () {
              return `<span style="color:#286CE3">${this.key}</span><br>
            <span style="font-family:DINAlternate-Bold">${this.y}%</span>`;
            }

          }
        }
      },
      series: [{
        type: 'pie',
        innerSize: '65%',
        name: '',
        data: []
      }]
    };
  }
};
